import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { SvgIcon, SvgFill } from '@chegg-ui/svg-icon';
var JournalEntry = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement(SvgFill, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39 29.134c-.5 0-.9.399-.9.997v2.395H1.9v-7.583h12.7c.5 0 1-.399 1-.997a1 1 0 0 0-1-.998H1.9v-7.583h11.4c.5 0 .9-.399.9-.898s-.4-.998-.9-.998H1.9V6.984c0-.599.5-.998 1.1-.998h10.4c.5 0 .9-.399.9-.898 0-.498-.4-.997-.9-.997H3c-1.6 0-3 1.297-3 2.993v33.923C0 42.603 1.3 44 3 44h34c1.6 0 3-1.297 3-2.993V30.132c-.1-.6-.5-.998-1-.998Zm-1 11.773c0 .599-.5.998-1.1.998H3a1 1 0 0 1-1-.998v-6.585h36v6.585Z"
  }), /*#__PURE__*/React.createElement(SvgFill, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.4 0c-7.5 0-13.6 6.086-13.6 13.57 0 7.482 6.1 13.568 13.6 13.568S44 21.052 44 13.57C44 6.086 37.9 0 30.4 0Zm0 25.243c-6.5 0-11.7-5.189-11.7-11.674 0-6.485 5.2-11.673 11.7-11.673 6.5 0 11.7 5.188 11.7 11.673s-5.3 11.674-11.7 11.674Z"
  }), /*#__PURE__*/React.createElement(SvgFill, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.8 14.966c-.3-.499-.7-.998-1.2-1.297-.7-.4-1.5-.699-2.2-.898v-4.69c.4.1.8.3 1.1.5.6.399.9.997.9 1.596 0 .499.4.998.9.998s1-.4 1-.998c0-1.397-.7-2.395-1.6-3.193-.7-.499-1.4-.798-2.3-.998v-.598a1 1 0 0 0-2 0v.798c-2.1.399-3.9 1.995-3.9 4.09 0 .7.1 1.398.5 1.896.3.5.7.998 1.2 1.198.7.399 1.5.698 2.2.898v4.789c-1.2-.3-2-1.297-2-2.195 0-.5-.4-.898-1-.898-.5 0-1 .399-1 .898 0 2.195 1.8 3.791 3.9 4.09v.799a1 1 0 0 0 2 0v-.799c2.1-.399 3.9-1.995 3.9-4.19 0-.599-.1-1.297-.4-1.796Zm-5.4-2.594c-.5-.1-.9-.3-1.2-.499-.3-.2-.4-.4-.6-.599-.1-.2-.2-.498-.2-.997 0-.898.8-1.896 2-2.195v4.29Zm1.9 6.685v-4.29c.5.1.9.299 1.2.498.3.2.4.3.6.599.1.2.2.499.2.998 0 .898-.7 1.895-2 2.195Z"
  }));
});
JournalEntry.displayName = 'JournalEntry';
JournalEntry.defaultProps = {
  'aria-label': 'JournalEntry'
};
export default JournalEntry;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg-ui/horizon-icons/dist/esm/icons/Editor/JournalEntry.js
// module id = 3553
// module chunks = 11